import { Module, Mutation, Action, VuexModule } from "vuex-module-decorators";
import { Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/services/ApiService";

import i18n from "@/i18n";

export const BASE_ENDPOINT = "api/v1/LandingPageLayout/GetVersion";

@Module({ name: "componentVersionModule" })
export default class ComponentVersionModule extends VuexModule {
  version = "";

  get getVersion(): string {
    return this.version;
  }

  @Mutation
  [Mutations.GET_BACKEND_VERSION](version: string): void {
    this.version = version;
  }

  @Action({ rawError: true })
  getBackendComponentVersionAction(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      ApiService.get(BASE_ENDPOINT)
        .then(({ data }) => {
          this.context.commit(Mutations.GET_BACKEND_VERSION, data);
          resolve();
        })
        .catch((error) => {
          const errorMessage = i18n.t(
            "alerts.componentVersionModule.errorRetrievingBackendComponentVersion"
          );
          this.context.commit(Mutations.SHOW_USER_FEEDBACK, {
            timeout: 5000,
            color: "error",
            message: `${errorMessage} <br/>"${error.message}"`,
          });
          console.log(`${errorMessage} ${error}`);
          reject(error);
        });
    });
  }
}
